import AssessmentIcon from '@mui/icons-material/Assessment'
import DashboardIcon from '@mui/icons-material/Dashboard'
import FlagIcon from '@mui/icons-material/Flag'
import HelpIcon from '@mui/icons-material/Help'
import SettingsIcon from '@mui/icons-material/Settings'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import HomeIcon from '@mui/icons-material/Home'
import { Translation } from 'react-i18next'

const home = {
  path: route('partner.home'),
  name: <Translation>{(t) => t('SLIDE_BAR.HOME')}</Translation>,
  icon: HomeIcon,
  iconColor: 'ErrorLight',
}

const dashboard = {
  path: route('partner.dashboard'),
  name: <Translation>{(t) => t('SLIDE_BAR.DASHBOARD')}</Translation>,
  icon: DashboardIcon,
  iconColor: 'ErrorLight',
}

const campaignManagement = {
  name: <Translation>{(t) => t('SLIDE_BAR.CAMPAIGN_MANAGEMENT')}</Translation>,
  icon: FlagIcon,
  iconColor: 'ErrorLight',
  children: [
    {
      path: route('partner.campaigns.index'),
      name: <Translation>{(t) => t('SLIDE_BAR.LIST_CAMPAIGNS')}</Translation>,
      icon: FormatListBulletedIcon,
    },
    {
      path: route('partner.campaigns.request'),
      name: <Translation>{(t) => t('SLIDE_BAR.REQUESTED_CAMPAIGN')}</Translation>,
      icon: FormatListBulletedIcon,
    },
  ],
}

const support = {
  path: '/support',
  name: <Translation>{(t) => t('SLIDE_BAR.SUPPORT')}</Translation>,
  icon: HelpIcon,
}

const setting = {
  path: route('partner.settings.index'),
  name: <Translation>{(t) => t('SLIDE_BAR.SETTING')}</Translation>,
  icon: SettingsIcon,
}

const report = {
  path: route('partner.report.index'),
  name: <Translation>{(t) => t('SLIDE_BAR.REPORT')}</Translation>,
  icon: AssessmentIcon,
  iconColor: 'ErrorLight',
}

const routes = [home, dashboard, campaignManagement, setting, report]

export default routes
